import styled, { css } from 'styled-components';

const PRODUCT_SLOT_SIZE = 56;
const FADED_JADE = '#ceeedb';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sizes-20);
  align-self: stretch;
`;

export const SectionTitle = styled.span`
  text-transform: uppercase;
  color: var(--color-gray-80);
  font: var(--font-extra-small-12pt-bold-caps);
`;

export const Card = styled.div`
  display: flex;
  padding: var(--sizes-40);
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--sizes-40);
  align-self: stretch;
  border-radius: var(--sizes-20);
  background: ${FADED_JADE};
  width: 100%;
`;

export const CardTitle = styled.div`
  font: var(--font-large-16pt-semibold);
  color: var(--color-grayscale-black);
`;

export const ProductSlots = styled.ul<{ $numberOfColumns: number }>`
  display: grid;
  gap: var(--sizes-20);
  list-style: none;
  justify-content: start;
  margin: 0;
  padding: 0;

  ${({ $numberOfColumns }) => css`
    grid-template-columns: repeat(${$numberOfColumns}, minmax(${PRODUCT_SLOT_SIZE}px, 160px));
  `}
`;

export const ProductSlot = styled.li`
  align-items: center;
  background: var(--color-brand-primary-white);
  border-radius: var(--sizes-20);
  display: flex;
  justify-content: center;
  height: ${PRODUCT_SLOT_SIZE}px;
`;

export const DescriptionWithIcon = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--sizes-30);
  height: 40px;
`;

const getCircleStyles = ({ backgroundColor, size }: { backgroundColor: string; size: number }) => css`
  height: ${size}px;
  width: ${size}px;
  background-color: ${backgroundColor};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IconContainerOuter = styled.div`
  ${() => getCircleStyles({ backgroundColor: 'var(--color-brand-primary-white)', size: 38 })}
`;

export const IconContainerInner = styled.div`
  ${() => getCircleStyles({ backgroundColor: FADED_JADE, size: 30 })}
`;

export const Description = styled.div`
  font: var(--font-regular-14pt-normal);
  color: var(--color-grayscale-black);
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const DescriptionTitle = styled.div`
  font-weight: 600;
  line-height: 17px;
`;

export const DescriptionText = styled.div`
  line-height: 17px;
`;

export const HelperText = styled.div`
  font: var(--font-extra-small-12pt-normal);
  color: var(--color-gray-90);
`;
